import LegalPage from "@/components/LegalPage";

const SECTIONS = [
  {
    heading: "Acceptance of Terms",
    body: [
      "By accessing or using the Network in Colors website (the \"Site\"), you agree to be bound by these Terms and Conditions. If you do not agree with any part of these terms, please do not use the Site.",
      "Network in Colors reserves the right to update these Terms and Conditions at any time. Changes take effect when posted on this page, and your continued use of the Site after changes are posted constitutes acceptance of the revised terms.",
    ],
  },
  {
    heading: "Our Services",
    body: [
      "Network in Colors provides fractional Human Resources and Operations leadership, manager and leadership development, and team building and restoration services to businesses. The content on this Site is provided for general informational purposes and describes the nature of our services.",
      "Submitting a consultation enquiry through the Site does not create a client relationship. A consulting engagement begins only when both parties have agreed to and signed a separate services agreement.",
    ],
  },
  {
    heading: "No Legal or Professional Advice",
    body: [
      "The information provided on this Site, and any general guidance offered during an initial consultation, is not legal, tax, accounting, or other licensed professional advice. Human Resources consulting involves judgment and general best practices; it is not a substitute for advice from a licensed attorney regarding employment law or other legal matters.",
      "You should consult qualified legal counsel before making decisions with legal implications for your business.",
    ],
  },
  {
    heading: "Use of the Site",
    body: [
      "You agree to use the Site only for lawful purposes and in a way that does not infringe the rights of, restrict, or inhibit anyone else's use of the Site. You may not attempt to gain unauthorized access to the Site, its servers, or any connected systems.",
      "You may not submit false, misleading, or fraudulent information through our contact forms, or submit enquiries on behalf of others without their knowledge.",
    ],
  },
  {
    heading: "Intellectual Property",
    body: [
      "All content on this Site, including text, graphics, logos, and design, is the property of Network in Colors or its content suppliers and is protected by applicable intellectual property laws. You may not reproduce, distribute, or create derivative works from Site content without our prior written permission.",
    ],
  },
  {
    heading: "Confidentiality",
    body: [
      "Information you share with us through the Site's contact form is treated with care and used only to respond to your enquiry and explore a potential engagement. Formal confidentiality obligations, where applicable, are defined in the services agreement signed for each engagement.",
    ],
  },
  {
    heading: "Limitation of Liability",
    body: [
      "To the fullest extent permitted by law, Network in Colors shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or related to your use of the Site or reliance on its content. The Site is provided on an \"as is\" and \"as available\" basis without warranties of any kind, express or implied.",
    ],
  },
  {
    heading: "Third-Party Links and Services",
    body: [
      "The Site may contain links to third-party websites or use third-party services (such as email delivery providers). We are not responsible for the content, accuracy, or practices of third-party sites and services, and inclusion of a link does not imply endorsement.",
    ],
  },
  {
    heading: "Governing Law",
    body: [
      "These Terms and Conditions are governed by the laws of the jurisdiction in which Network in Colors is headquartered, without regard to conflict of law principles. Any disputes arising from these terms or your use of the Site shall be resolved in the courts of that jurisdiction.",
    ],
  },
  {
    heading: "Contact Us",
    body: [
      "If you have questions about these Terms and Conditions, contact us at michelle@networkincolors.com.",
    ],
  },
];

const Terms = () => (
  <LegalPage
    title="Terms and Conditions"
    updated="August 2026"
    sections={SECTIONS}
    testId="terms-page"
  />
);

export default Terms;
